(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('scd-cart-summary')) {
  customElements.define('scd-cart-summary', class extends HTMLElement {
    connectedCallback() {
      this.refresh = async () => {
        if (this.loading || document.hidden) return;
        this.loading = true;
        try {
          const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          const currency = cart.currency || this.dataset.currency;
          const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
          document.querySelectorAll('scd-cart-summary').forEach(summary => {
            if (summary.classList.contains('scd-cart-summary--footer')) summary.hidden = cart.item_count === 0;
            const threshold = Number(summary.dataset.threshold);
            const remaining = Math.max(0, threshold - cart.total_price);
            summary.querySelector('[data-summary-count]').textContent = cart.item_count === 1 ? summary.dataset.oneItem : summary.dataset.items.replace('[count]', cart.item_count);
            summary.querySelector('[data-summary-total]').textContent = money(cart.total_price) + ' ' + currency;
            summary.querySelector('.scd-cart-summary__shipping').hidden = currency !== 'USD';
            summary.querySelector('[data-summary-message]').textContent = remaining > 0 ? summary.dataset.remaining.replace('[amount]', money(remaining)) : summary.dataset.unlocked;
            summary.querySelector('[data-summary-progress]').value = threshold > 0 ? Math.min(100, Math.max(0, cart.total_price / threshold * 100)) : 0;
          });
        } catch (error) {
          return;
        } finally {
          this.loading = false;
        }
      };
      if (this.classList.contains('scd-cart-summary--footer')) {
        this.measure = () => {
          const space = this.hidden ? 0 : this.getBoundingClientRect().height + (parseFloat(getComputedStyle(this).bottom) || 0) + 8;
          document.documentElement.style.setProperty('--scd-cart-bar-height', `${space}px`);
        };
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this);
        this.measure();
        window.addEventListener('pageshow', this.refresh);
        window.addEventListener('focus', this.refresh);
        document.addEventListener('cart:updated', this.refresh);
        document.addEventListener('cart:change', this.refresh);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('pageshow', this.refresh);
      window.removeEventListener('focus', this.refresh);
      document.removeEventListener('cart:updated', this.refresh);
      document.removeEventListener('cart:change', this.refresh);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const initializeGalleryFinishNotes = () => {
    document.querySelectorAll('[data-gallery-finish-note]').forEach((note) => {
      if (note.dataset.initialized) return;
      const section = note.closest('.product-section');
      const select = section?.querySelector('[data-variant-select]');
      if (!select) return;
      const updateNote = () => {
        note.hidden = Boolean(select.selectedOptions[0]?.dataset.image);
      };
      select.addEventListener('change', updateNote);
      note.dataset.initialized = 'true';
      updateNote();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGalleryFinishNotes);
  } else {
    initializeGalleryFinishNotes();
  }
  document.addEventListener('shopify:section:load', initializeGalleryFinishNotes);
})();

  } catch(e) { console.error(e); }
})();
})();
